module.exports = __webpack_public_path__ + "static/media/staffs.451c2a64.svg";